// Terms and Conditions Checkbox functionality for Cart Page and Cart Drawer
class CartTermsCheckbox {
  constructor() {
    this.init();
    // Re-initialize when cart drawer is refreshed
    document.addEventListener('cart-drawer:refresh', () => {
      setTimeout(() => this.init(), 200);
    });
  }

  init() {
    // Use setTimeout to ensure DOM is fully ready (helps with Safari/iOS)
    setTimeout(() => {
      // Cart Page Checkbox
      const cartPageCheckbox = document.getElementById('cart-page-terms');
      const cartPageButton = document.querySelector('.cart-page .cart-checkout-button');

      if (cartPageCheckbox && cartPageButton) {
        this.setupCheckbox(cartPageCheckbox, cartPageButton);
      }

      // Cart Drawer Checkbox
      const cartDrawerCheckbox = document.getElementById('cart-drawer-terms');
      const cartDrawerButton = document.querySelector('#CartDrawer-Checkout');

      if (cartDrawerCheckbox && cartDrawerButton) {
        this.setupCheckbox(cartDrawerCheckbox, cartDrawerButton);
      }
    }, 100);
  }

  setupCheckbox(checkbox, button) {
    // Skip if already initialized
    if (checkbox.dataset.termsInitialized === 'true') {
      // Just update the button state
      this.setButtonState(button, checkbox.checked);
      return;
    }
    
    // Mark as initialized
    checkbox.dataset.termsInitialized = 'true';
    
    // Set initial state - button should be disabled
    this.setButtonState(button, checkbox.checked);

    // Create handler function
    const handleChange = () => {
      const isChecked = checkbox.checked;
      this.setButtonState(button, isChecked);
    };

    // Listen for multiple events (Safari/iOS compatibility)
    checkbox.addEventListener('change', handleChange);
    checkbox.addEventListener('click', handleChange);
    checkbox.addEventListener('input', handleChange);
    
    // Also listen on the label
    const label = checkbox.closest('label');
    if (label) {
      label.addEventListener('click', (e) => {
        // Small delay to let checkbox state update
        setTimeout(handleChange, 10);
      });
    }

    // Prevent form submission if checkbox is not checked
    const form = button.form;
    if (form) {
      form.addEventListener('submit', (e) => {
        if (!checkbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Shake the checkbox to draw attention
          const label = checkbox.closest('label');
          if (label) {
            label.style.animation = 'shake 0.5s';
            setTimeout(() => {
              label.style.animation = '';
            }, 500);
          }
          
          return false;
        }
      });
    }

    // Handle button click directly
    button.addEventListener('click', (e) => {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    });
  }

  setButtonState(button, isEnabled) {
    if (isEnabled) {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.style.opacity = '1';
      button.style.cursor = 'pointer';
      button.style.pointerEvents = 'auto';
    } else {
      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
      button.style.opacity = '0.5';
      button.style.cursor = 'not-allowed';
      button.style.pointerEvents = 'none';
    }
  }
}

// Add shake animation
if (!document.querySelector('#cart-terms-shake-animation')) {
  const style = document.createElement('style');
  style.id = 'cart-terms-shake-animation';
  style.textContent = `
    @keyframes shake {
      0%, 100% { transform: translateX(0); }
      25% { transform: translateX(-5px); }
      75% { transform: translateX(5px); }
    }
  `;
  document.head.appendChild(style);
}

// Multiple initialization attempts for Safari/iOS compatibility
let termsInstance = null;

function initTermsCheckbox() {
  if (!termsInstance) {
    termsInstance = new CartTermsCheckbox();
  } else {
    termsInstance.init();
  }
}

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTermsCheckbox);
} else {
  initTermsCheckbox();
}

// Initialize after window load (Safari sometimes needs this)
window.addEventListener('load', () => {
  setTimeout(initTermsCheckbox, 100);
});

// Re-initialize when Shopify section is rendered (for cart page)
document.addEventListener('shopify:section:load', initTermsCheckbox);

// Re-initialize on cart updates
document.addEventListener('cart:updated', () => {
  setTimeout(initTermsCheckbox, 200);
});

// Watch for DOM changes (for dynamically loaded cart drawer)
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        const hasCartTerms = document.getElementById('cart-page-terms') || 
                            document.getElementById('cart-drawer-terms');
        if (hasCartTerms) {
          setTimeout(initTermsCheckbox, 50);
          break;
        }
      }
    }
  });

  // Start observing after a short delay
  setTimeout(() => {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }, 100);
}
